export default "__VITE_ASSET__ceb57fd7__"